import { useMemo } from 'react'
import { StockType } from 'types/stock'

const useHasChangedDeadline = (prevStocks: StockType[], nextStocks: StockType[], isNoStock: boolean): boolean => {
  return useMemo(() => {
    if (isNoStock) return true
    return prevStocks.some((prevStock) =>
      nextStocks.some(
        (nextStock) =>
          nextStock.stock_ref?.id === prevStock.stock_ref?.id && !nextStock.deadline.isEqual(prevStock.deadline)
      )
    )
  }, [prevStocks, nextStocks, isNoStock])
}

export default useHasChangedDeadline
